import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiTileList, { type TileListType, type TileOption } from '@/modules/ui/components/ui/UiTileList.vue';

type SchemaTileListArgs = SchemaControlArgs & {
  options: (TileOption | false)[];
  type?: TileListType;
};

export class SchemaTileList extends SchemaControl<never> {
  readonly component = UiTileList;
  readonly options: TileOption[];
  readonly type?: TileListType;

  constructor(args: SchemaTileListArgs) {
    super(args);

    this.options = args.options.filter((option) => option !== false);
    this.type = args.type;
  }
}
